import { Fragment } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiTableRow } from 'shell/components/shared/table/row';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Tooltip } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import { DocumentRegistryItemVM } from 'civil-status/view-models/document-registry-list';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';

export const authsRowDocumentRegistry = {
  read: [CivilStatusAuthorizations.DocumentiRegistroQuery],
  delete: [CivilStatusAuthorizations.DocumentiRegistroDelete],
  update: [CivilStatusAuthorizations.DocumentiRegistroUpdate],
  add: [CivilStatusAuthorizations.DocumentiRegistroAdd],
};

interface TableRowComponentProps {
  item: DocumentRegistryItemVM;
  onTrashPress: (item: DocumentRegistryItemVM) => void;
  onVisibilityPress: (item: DocumentRegistryItemVM) => void;
  onEditPress: (item: DocumentRegistryItemVM) => void;
}

const TableRowComponent = ({
  item,
  onTrashPress,
  onVisibilityPress,
  onEditPress,
}: TableRowComponentProps): React.ReactElement => {
  const auths = useActionAuthorization(authsRowDocumentRegistry);

  return (
    <Fragment>
      <PmiTableRow>
        <PmiBodyTableCell scope="row">{item.number}</PmiBodyTableCell>
        <PmiBodyTableCell scope="row">{item.description}</PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <div className="pmi-d-flex">
            <Tooltip
              arrow
              title={
                auths.read
                  ? 'Visualizza'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="visualizza"
                  component="span"
                  onClick={() => onVisibilityPress(item)}
                  disabled={!auths.read}
                >
                  <Visibility />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.update
                  ? 'Aggiorna'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="modifica"
                  component="span"
                  onClick={() => onEditPress(item)}
                  disabled={!auths.update}
                >
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.delete
                  ? 'Elimina'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  color="error"
                  aria-label="elimina"
                  component="span"
                  disabled={!auths.delete}
                  onClick={() => onTrashPress(item)}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </PmiBodyTableCell>
      </PmiTableRow>
    </Fragment>
  );
};

TableRowComponent.displayName = 'Table row component';

export default TableRowComponent;
